import React from "react";
import { getDate } from "utils/formatDate";
import { formatNumber2 } from "utils/currencyFormat";
import { BtnChiTietHopDong } from "./ChiTiet/BtnChiTietHopDong";
import { BtnChiTietNhanVay } from "./ChiTiet/BtnChiTietNhanVay";
import { BtnChiTietKhachHang } from "./ChiTiet/BtnChiTietKhachHang";

const GiaoDichModelType = {
    None: 0,
    ChoVay: 1,
    NhanVay: 3,
    ThuChi: 2
};

export const ContentTable = ({ listDanhSach, phanQuyen, dataSearch }) => {

    if (!listDanhSach || listDanhSach.length === 0) {
        return (
            <div className="custom-table-row no-data" style={{ minHeight: 56, justifyContent: 'center' }}>
                <p>Không có dữ liệu</p>
            </div>
        );
    }

    const pageStartIndex = (dataSearch.pageIndex - 1) * dataSearch.pageSize;
    const renderMaGiaoDich = (item) => {
        if (!phanQuyen.giaodichtrongngay_chitietmagiaodich) {
            return item.GiaoDichCode;
        }
        switch (item.DetailType) {
            case GiaoDichModelType.ChoVay:
                return <BtnChiTietHopDong item={{ ChoVayId: item.ChoVayId, ContractCode: item.GiaoDichCode }} />;

            case GiaoDichModelType.NhanVay:
                return <BtnChiTietNhanVay item={item} />;

            case GiaoDichModelType.ThuChi:
                return <a href="#!" className="blue btn-link">{item.GiaoDichCode}</a>;

            default:
                return item.GiaoDichCode;
        }
    };

    const renderKhachHang = (item) => {
        if (!phanQuyen.giaodichtrongngay_chitietkhachhang || !item.CustomerId) {
            return item.GiaoDichName;
        }
        return <BtnChiTietKhachHang item={{ CustomerID: item.CustomerId, TenKhachHang: item.GiaoDichName }} />;
    };

    return (
        <>
            {listDanhSach.map((item, index) => {
                const soTien = item.GiaoDichValue ?? 0;
                const cellStyle = {
                    color: soTien < 0 ? '#FF5170' : (soTien > 0 ? '#00B69B' : '#000')
                };

                return (
                    <div
                        key={item.GiaoDichId}
                        className="custom-table-row"
                        style={{ minHeight: "56px", borderBottom: '1px solid #e0e0e0' }}
                    >
                        <div className="custom-table-cell flex-basis-5 flex-basis-5-sm">
                            <span className="mobile-column-name color7-bold">STT</span>
                            <div className="center-wrapper word-break text-center" style={{ justifyContent: 'center' }}>
                                {pageStartIndex + index + 1}
                            </div>
                        </div>
                        <div className="custom-table-cell text-left flex-basis-12 flex-basis-12-sm">
                            <span className="mobile-column-name color7-bold">Mã giao dịch</span>
                            <div className="center-wrapper word-break">
                                {renderMaGiaoDich(item)}
                            </div>
                        </div>
                        <div className="custom-table-cell text-left flex-basis-15 flex-basis-15-sm">
                            <span className="mobile-column-name color7-bold">Loại</span>
                            <div
                                className="center-wrapper word-break"
                                dangerouslySetInnerHTML={{ __html: item.Type }}
                            />
                        </div>
                        <div className="custom-table-cell text-left flex-basis-18 flex-basis-18-sm">
                            <span className="mobile-column-name color7-bold">Nhân viên</span>
                            <div className="center-wrapper word-break">
                                {item.GiaoDichUserName}
                            </div>
                        </div>
                        <div className="custom-table-cell text-left flex-basis-15 flex-basis-15-sm">
                            <span className="mobile-column-name color7-bold">Khách hàng</span>
                            <div className="center-wrapper word-break">
                                {renderKhachHang(item)}
                            </div>
                        </div>
                        <div className="custom-table-cell text-left flex-basis-10 flex-basis-10-sm">
                            <span className="mobile-column-name color7-bold">Ngày tạo</span>
                            <div className="center-wrapper word-break">
                                {getDate(item.GiaoDichTime)}
                            </div>
                        </div>
                        <div className="custom-table-cell text-left flex-basis-10 flex-basis-10-sm">
                            <span className="mobile-column-name color7-bold">Ngày thu/chi</span>
                            <div className="center-wrapper word-break">
                                {getDate(item.ThuChiTime)}
                            </div>
                        </div>
                        <div className="custom-table-cell flex-basis-15 flex-basis-15-sm">
                            <span className="mobile-column-name color7-bold">Số tiền</span>
                            <div className="center-wrapper word-break text-right" style={{ ...cellStyle, fontWeight: 'bold' }}>
                                {formatNumber2(soTien)}
                            </div>
                        </div>
                    </div>
                );
            })}
        </>
    );
};